import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

/**
 * Icon Component
 *
 * @param {import('./interfaces').IconProps} props
 * @returns {JSX.Element>}
 */
function Icon ({ name, title = name, className, size, ariaHidden, ariaLabel = title || name, desc, isFocusable, ...rest }) {
  const iconId = `zb-icon-${name}`
  const xlink = `#${iconId}`
  const newProps = {
    focusable: false,
    'aria-hidden': ariaHidden,
    'aria-label': ariaLabel,
    title,
    className: classNames(
      className,
      iconId,
      'zb-icon',
      size ? `zb-icon-${size}` : ''
    ),
    tabIndex: isFocusable ? 0 : null,
    ...rest
  }

  return (
    <svg {...newProps}>
      {title && <title>{title}</title>}
      {desc && <desc>{desc}</desc>}
      <use xlinkHref={xlink} />
    </svg>
  )
}

const propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string,
  size: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge']),
  desc: PropTypes.string,
  ariaHidden: PropTypes.bool,
  ariaLabel: PropTypes.string,
  isFocusable: PropTypes.bool
}
Icon.propTypes = propTypes

const defaultProps = {
  ariaHidden: false,
  isFocusable: false
}

Icon.defaultProps = defaultProps

export default Icon
export { Icon, propTypes, defaultProps }
